import request from 'utils/request';

export const updateOrganization = data => request.put(`/organizations/${data.id}`, data);
export const getOrganization = () => request.get(`/organizations/company`);
